export function decodeHtmlEntities(value = "") {
  if (!value) {
    return "";
  }

  const textarea = document.createElement("textarea");
  textarea.innerHTML = value.toString();

  return textarea.value;
}

export function normalizeText(value = "") {
  return decodeHtmlEntities(value)
    .replace(/\u00a0/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function slugify(value = "") {
  return normalizeText(value)
    .toLowerCase()

    // Common course title replacements for SEO-friendly detail URLs
    .replace(/c\+\+/g, " c plus plus ")
    .replace(/c#/g, " c sharp ")
    .replace(/\.net/g, " dot net ")
    .replace(/node\.js/g, " node js ")
    .replace(/react\.js/g, " react js ")
    .replace(/vue\.js/g, " vue js ")

    // Common symbol replacements
    .replace(/&/g, " and ")
    .replace(/\+/g, " plus ")
    .replace(/#/g, " sharp ")
    .replace(/%/g, " percent ")
    .replace(/\$/g, " dollar ")
    .replace(/@/g, " at ")

    // Remove quotes and apostrophes cleanly
    .replace(/["'’‘`]/g, "")

    // Convert separators and remaining special characters to spaces
    .replace(/[\/\\|:;,.()[\]{}<>!?*=~^]+/g, " ")
    .replace(/[^a-z0-9\s-]/g, " ")

    // Spaces to dashes
    .replace(/\s+/g, "-")

    // Collapse repeated dashes and trim edges
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function getCourseSlug(course = {}) {
  const existingSlug = normalizeText(
    course.slug ||
      course.course_slug ||
      course.post_name ||
      ""
  );

  if (existingSlug) {
    return slugify(existingSlug);
  }

  return slugify(
    course.post_title ||
      course.title ||
      course.name ||
      ""
  );
}

export function unslugify(value = "") {
  return normalizeText(value)
    .replace(/-/g, " ")
    .trim();
}

export function encodeSearchKeyword(value = "") {
  return encodeURIComponent(normalizeText(value));
}

export function decodeSearchKeyword(value = "") {
  const decodedValue = safeDecodeURIComponent(value);

  // Backward compatibility for old generated search URLs such as /courses/search/c-sharp
  return normalizeText(decodedValue)
    .replace(/\bc-sharp\b/gi, "C#")
    .replace(/\bc-plus-plus\b/gi, "C++")
    .replace(/\bdot-net\b/gi, ".NET")
    .replace(/\bnode-js\b/gi, "Node.js")
    .replace(/\breact-js\b/gi, "React.js")
    .replace(/\bvue-js\b/gi, "Vue.js")
    .replace(/-/g, " ")
    .trim();
}

function safeDecodeURIComponent(value = "") {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}
